import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "QqPlot"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M15 4.5C15.8284 4.5 16.5 3.82843 16.5 3 16.5 2.17157 15.8284 1.5 15 1.5 14.1716 1.5 13.5 2.17157 13.5 3 13.5 3.82843 14.1716 4.5 15 4.5zM6 13.5C6.82843 13.5 7.5 12.8284 7.5 12 7.5 11.1716 6.82843 10.5 6 10.5 5.17157 10.5 4.5 11.1716 4.5 12 4.5 12.8284 5.17157 13.5 6 13.5zM21 10.5C21.8284 10.5 22.5 9.82843 22.5 9 22.5 8.17157 21.8284 7.5 21 7.5 20.1716 7.5 19.5 8.17157 19.5 9 19.5 9.82843 20.1716 10.5 21 10.5zM8.25 6.75C9.07843 6.75 9.75 6.07843 9.75 5.25 9.75 4.42157 9.07843 3.75 8.25 3.75 7.42157 3.75 6.75 4.42157 6.75 5.25 6.75 6.07843 7.42157 6.75 8.25 6.75zM12 19.5C12.8284 19.5 13.5 18.8284 13.5 18 13.5 17.1716 12.8284 16.5 12 16.5 11.1716 16.5 10.5 17.1716 10.5 18 10.5 18.8284 11.1716 19.5 12 19.5z" }, null, -1);
const _hoisted_3 = /* @__PURE__ */ _createElementVNode("path", { d: "M22.5 2.55982L21.4394 1.5L3 19.9387V1.5H1.5V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H22.5V21H4.05982L22.5 2.55982Z" }, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/QqPlot.vue"]]);
